import _class_call_check from "@swc/helpers/src/_class_call_check.mjs";
import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _sliced_to_array from "@swc/helpers/src/_sliced_to_array.mjs";
import { utils } from "@alife/cone-arms-core";
import { onFCP, onLCP } from "web-vitals";
var getCommonInfo = utils.getCommonInfo, checkWin = utils.checkWin, watchPageVisibilityChange = utils.watchPageVisibilityChange, bindEvent = utils.bindEvent, getXPath = utils.getXPath, hookHashChange = utils.hookHashChange, hookHistory = utils.hookHistory, supportedEntryType = utils.supportedEntryType;
// 如果初始化插件时页面已经onload，直接获取performance并发送
// 如果初始化插件时页面还没有onload，则等页面onload时再获取performance并发送
var onLoad = function onLoad(callback) {
    var setTimeoutOnWindow = function setTimeoutOnWindow() {
        timer = setTimeout(callback);
    };
    var timer;
    if (document.readyState === "complete") timer = setTimeout(callback);
    else window.addEventListener("load", setTimeoutOnWindow);
    return function() {
        if (timer) clearTimeout(timer);
        window.removeEventListener("load", setTimeoutOnWindow);
    };
};
var Perf = /*#__PURE__*/ function() {
    "use strict";
    function Perf(core) {
        var _this = this;
        _class_call_check(this, Perf);
        this.observerTiming = function() {
            var _window_performance;
            var fixTiming = function(originTiming, startTimeKey) {
                if (originTiming && originTiming[startTimeKey] > 0) {
                    var timing = {};
                    for(var key in originTiming)if (key !== startTimeKey && originTiming[key] >= originTiming[startTimeKey]) timing[key] = Math.ceil(originTiming[key] - originTiming[startTimeKey]);
                    else timing[key] = Math.ceil(originTiming[key]);
                    return timing;
                }
                return originTiming;
            };
            if (supportedEntryType("navigation")) new PerformanceObserver(function(entryList) {
                var _entryList_getEntriesByType = _sliced_to_array(entryList.getEntriesByType("navigation"), 1), pageNav = _entryList_getEntriesByType[0];
                _this.navigationTiming = fixTiming(pageNav, "startTime");
            }).observe({
                type: "navigation",
                buffered: true
            });
            else if (window === null || window === void 0 ? void 0 : (_window_performance = window.performance) === null || _window_performance === void 0 ? void 0 : _window_performance.timing) _this.navigationTiming = fixTiming(window.performance.timing, "navigationStart");
        };
        this.observerFCP = function() {
            var entryType = "paint";
            if (supportedEntryType(entryType)) onFCP(function(fcpMetric) {
                if (fcpMetric.value > 0) _this.fcp = Math.ceil(fcpMetric.value);
            });
        };
        this.observerLCP = function() {
            var entryType = "largest-contentful-paint";
            if (supportedEntryType(entryType)) onLCP(function(lcpMetric) {
                _this.lcpMetric = lcpMetric;
            }, {
                reportAllChanges: true
            });
        };
        this.getConnection = function() {
            var _window_navigator;
            var connectionData = {};
            // @ts-ignore get connection
            var connection = window === null || window === void 0 ? void 0 : (_window_navigator = window.navigator) === null || _window_navigator === void 0 ? void 0 : _window_navigator.connection;
            if (typeof connection === "object" && connection) {
                // 网络连接类型 connection type,例：wifi, 3g,目前只在 chrome 中能拿到数据
                var net_type = connection.effectiveType || connection.type || "";
                // 网络带宽 connection bandwidth，单位 Mbps
                var downlink = connection.downlink || connection.downlinkMax || connection.bandwidth || "";
                connectionData = {
                    net_type: net_type,
                    downlink: downlink
                };
            }
            return connectionData;
        };
        this.sendTiming = function() {
            var _this_lcpMetric;
            if (_this.hasSendPerf || !_this.navigationTiming) return;
            _this.hasSendPerf = true;
            var timing = _this.navigationTiming;
            var logItem = _object_spread({
                timing: timing,
                dnsTime: Math.ceil((timing.domainLookupEnd || 0) - (timing.domainLookupStart || 0)),
                ttfb: Math.ceil(timing.responseStart),
                domComplete: Math.ceil(timing.domComplete),
                totalTime: Math.ceil(timing.loadEventEnd),
                fcp: _this.fcp > 0 ? _this.fcp : Math.ceil(timing.domInteractive) || 0,
                lcp: _this.lcpMetric && _this.lcpMetric.value > 0 ? Math.ceil(_this.lcpMetric.value) : Math.ceil(timing.loadEventEnd)
            }, _this.getConnection());
            logItem.extendInfo = {};
            var resourceLoadData = _this.getResourceLoadOverview();
            if (resourceLoadData.resourceCount && resourceLoadData.resourceCount > 0) {
                logItem.extendInfo.resourceCount = resourceLoadData.resourceCount;
                delete resourceLoadData.resourceCount;
                Object.assign(logItem, resourceLoadData);
            }
            var serverExecTime = _this.getServerExecTime(timing);
            if (serverExecTime > 0) logItem.serverExecTime = serverExecTime;
            if (Array.isArray((_this_lcpMetric = _this.lcpMetric) === null || _this_lcpMetric === void 0 ? void 0 : _this_lcpMetric.entries) && _this.lcpMetric.entries.length > 0) {
                var entry = _this.lcpMetric.entries[_this.lcpMetric.entries.length - 1];
                if (entry && entry.element) logItem.extendInfo.lcpElement = getXPath(entry.element, 5);
            }
            _this.core.logPerformance(_object_spread({}, _this.commonInfo, logItem));
        };
        this.hasSendPerf = false;
        this.core = core;
        this.lcpElement = null;
        this.uninstallHooks = [];
        this.commonInfo = {};
        this.sendReportTimer = null;
        this.resourceEntries = [];
        this.fcp = 0;
        this.navigationTiming = null;
    }
    var _proto = Perf.prototype;
    _proto.getResourceLoadOverview = function getResourceLoadOverview() {
        var ret = {};
        if (!supportedEntryType("resource")) return ret;
        var useCacheCount = 0;
        var slowLoadResourceCount = 0;
        var resourceCount = 0;
        performance.getEntriesByType("resource").forEach(function(entry) {
            var fileTypeMatch = function() {
                var name = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
                if (name && typeof name.endsWith === "function") return name.endsWith(".js") || name.endsWith(".css");
                return false;
            };
            if (fileTypeMatch(entry.name)) {
                resourceCount++;
                if (entry.transferSize === 0 || entry.duration < 50) useCacheCount++;
                if (entry.duration > 1000) slowLoadResourceCount++;
            }
        });
        if (resourceCount > 0) return {
            slowLoadResourceCount: slowLoadResourceCount,
            cacheUseRate: (useCacheCount / resourceCount).toFixed(4),
            resourceCount: resourceCount
        };
        return ret;
    };
    _proto.getServerExecTime = function getServerExecTime(timing) {
        if (timing && Array.isArray(timing.serverTiming)) {
            var appTiming = timing.serverTiming.find(function(serverTimingEntry) {
                return serverTimingEntry && serverTimingEntry.name === "app";
            });
            if (appTiming && appTiming.duration) return appTiming.duration;
            return undefined;
        }
        return undefined;
    };
    _proto.initReport = function initReport() {
        var _this = this;
        var reset = function() {
            unbindBeforeunload();
            unbindHashChange();
            unbindHistoryChange();
            _this.sendReportTimer && clearTimeout(_this.sendReportTimer);
        };
        var doReport = function() {
            _this.sendTiming();
            reset();
        };
        var unbindBeforeunload = bindEvent(window, "beforeunload", doReport);
        watchPageVisibilityChange(doReport, true);
        this.sendReportTimer = setTimeout(doReport, 30000);
        var routeType = this.core.config.spaRouteType;
        var unbindHashChange = routeType && routeType !== "history" ? hookHashChange(doReport) : function() {};
        var unbindHistoryChange = routeType && routeType !== "hash" ? hookHistory(doReport) : function() {};
        return function() {
            reset();
        };
    };
    _proto.init = function init() {
        var _this = this;
        this.uninstallHooks = [];
        this.uninstallHooks.push(onLoad(function() {
            var _this_core_config;
            _this.observerTiming();
            _this.observerFCP();
            _this.observerLCP();
            _this.commonInfo = getCommonInfo(((_this_core_config = _this.core.config) === null || _this_core_config === void 0 ? void 0 : _this_core_config.ignoredQueries) || [], _this.core.config);
            _this.uninstallHooks.push(_this.initReport());
        }));
    };
    return Perf;
}();
var perfInstance;
var TraceWebPerformancePlugin = function(core, param) {
    var _param_singleton = param.singleton, singleton = _param_singleton === void 0 ? true : _param_singleton;
    if (!(core && checkWin() && typeof core.logPerformance === "function")) return [];
    // 性能上报需要单例，不重复上报
    if (singleton && perfInstance && perfInstance.uninstallHooks) return perfInstance.uninstallHooks;
    try {
        perfInstance = new Perf(core);
        perfInstance.init();
        return perfInstance.uninstallHooks;
    } catch (e) {
        console.warn(e);
    }
    return [];
};
export default TraceWebPerformancePlugin;
